// extracted by mini-css-extract-plugin
export default {"switch":"switch_switch__n04oM","slider":"switch_slider__x2rz-","round":"switch_round__RAI4u"};